import { FiHome, FiShoppingBag, FiScissors, FiPackage, FiEdit } from "react-icons/fi";
import { ROUTES } from "@/routes/paths";

/**
 * Primary navigation. Everything is public now that there are no accounts —
 * "My orders" reads from this device rather than from a signed-in session.
 */
export const PRIMARY_NAV = [
  { to: ROUTES.HOME, label: "Home", icon: FiHome, end: true },
  { to: ROUTES.PRODUCTS, label: "Products", icon: FiShoppingBag },
  { to: ROUTES.DESIGNERS, label: "Designers", icon: FiScissors },
  { to: ROUTES.CUSTOM_ORDERS, label: "Custom Orders", icon: FiEdit, hideOnMobile: true },
  { to: ROUTES.ORDERS, label: "My Orders", icon: FiPackage },
];

export const getVisibleNav = () => PRIMARY_NAV;

/** Items for the mobile bottom tab bar. */
export const getMobileNav = () => PRIMARY_NAV.filter((item) => !item.hideOnMobile);
